import {
  Fragment,
  Suspense,
  lazy,
} from 'react';
import {
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

import { LoadingScreen } from 'components';
import PermissionGuard from 'components/PermissionGuard';

import authenticationRoutes from './authentication';
import dashboardRoutes from './dashboard';

import AuthGuard from 'components/AuthGuard'; //TODO: Una vez pasada la beta retirar
import PosBetaGuard from './guards/PosBetaGuard'; //TODO: Una vez pasada la beta retirar

const error404 = {
  component: lazy(() => import('views/Errors/Error404')),
};

const redirect = () => <Redirect to="/dashboard" />;

const landingRoutes = {
  path: '*',
  routes: [error404],
};

//TODO: Una vez pasada la beta retirar
const posRoutes = [
  {
    exact: true,
    path: '/pos/products',
    guard: AuthGuard,
    layout: PosBetaGuard,
    component: lazy(() => import('views/POS/Products')),
  },
  {
    exact: true,
    path: '/pos/groups',
    guard: AuthGuard,
    layout: PosBetaGuard,
    component: lazy(() => import('views/POS/Groups')),
  },
  {
    exact: true,
    path: '/pos/sales',
    guard: AuthGuard,
    layout: PosBetaGuard,
    component: lazy(() => import('views/POS/Sales')),
  },
];
//TODO: --- Una vez pasada la beta retirar

const renderRoutes = (routes) =>
  routes ? (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        {routes.map((route, index) => {
          const Component = route.component;
          const Guard = route.guard || Fragment;
          const Layout = route.layout || Fragment;
          const Permission = route.permission
            ? PermissionGuard
            : Fragment;

          return (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              render={(props) => (
                <Guard>
                  <Layout>
                    {/* El Suspense va dentro del Layout: así la vista que se
                        descarga por primera vez (lazy) muestra el loader solo
                        en el contenido, sin quitar el menú ni la barra */}
                    {route.routes
                      ? (renderRoutes(route.routes))
                      : (<Suspense fallback={<LoadingScreen />}>
                        <Permission permission={route.permission}>
                          <Component {...props} />
                        </Permission>
                      </Suspense>)}
                  </Layout>
                </Guard>
              )}
            />
          );
        })}
      </Switch>
    </Suspense >
  ) : null;

function Routes() {
  return renderRoutes([
    {
      exact: true,
      path: '/',
      component: redirect,
    },
    authenticationRoutes,
    ...posRoutes,
    dashboardRoutes,
    landingRoutes,
    error404,
  ]);
}

export default Routes;
